const t = {
  root: {
    base: "relative inline-flex items-center rounded-full bg-intenseDark p-1 border border-mutedDark backdrop-blur-md shadow-inner",
    disabled: "opacity-50 cursor-not-allowed",
    compact: "p-0.5",
    fullWidth: "flex w-full"
  },
  indicator: {
    base: "absolute top-1 bottom-1 left-1 transition-transform duration-300 ease-in-out bg-accent shadow-[0_0_15px_rgba(179,234,213,0.3)] rounded-full",
    off: "translate-x-0",
    on: "translate-x-full",
    compact: "top-0.5 bottom-0.5 left-0.5"
  },
  button: {
    base: "relative z-10 w-24 px-4 py-1.5 rounded-full text-sm font-medium transition-colors duration-300 ease-in-out font-mono tracking-tight",
    active: {
      on: "text-intenseDark",
      off: "text-muted hover:text-foreground hover:cursor-pointer"
    },
    compact: "w-20 px-3 py-1 text-xs",
    fullWidth: "w-full flex-1"
  }
};
export {
  t as valueToggleTheme
};
